import { render, staticRenderFns } from "./courseListElement.vue?vue&type=template&id=b7d0ffe6"
import script from "./courseListElement.vue?vue&type=script&lang=js"
export * from "./courseListElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports